/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_7c3342c5"]'><div :class='["radio-disabled-demo"]'><view-desc>禁用选项: {{ radioValue }}</view-desc><div :class='["cube-radio-demos"]'><cube-radio :option="(radio)" :value="radioValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","radioValue", "__mpx_event__", ["value"], undefined]])'>disabledOption</cube-radio></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_7c3342c5"}'>
// .radio-disabled-demo
//   .cube-radio-example
//     padding 5px 10px
//     box-sizing border-box
//     background-color #fff
//   .desc
//     margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_7c3342c5"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_7c3342c5"}
  /** script content **/
  require("./radio-disabled.mpx.js?isComponent&outputPath=components%2Fradio-disabled7c3342c5%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./radio-disabled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fradio-disabled7c3342c5%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_7c3342c5"],
    ctorType: "component",
    outputPath: "components/radio-disabled7c3342c5/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-radio':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio/index.mpx?isComponent&outputPath=components%2Findex4aa5b228%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>